import React from 'react';
import ReactSVG from 'react-svg';
import loadingSpinner from '@assets/common/loading-spinner.svg';
import styles from './index.module.css';
import './styles.css';
import classNames from 'classnames';
import { ReactComponent as Loading } from '@assets/common/loading-spinner.svg';
import { Colors } from '@constants/constant';
import PropTypes from 'prop-types';


const LoadingSpinner = ({ className, isWhiteMode }) => (
  <div
    className={classNames({
      [styles.overlay]: true,
      [styles.overlayWhite]: isWhiteMode,
      [styles.overlayWhiteBlur]: isWhiteMode
    })}
  >
    <div
      className={classNames(styles.wrapper, {
        [className]: className
      })}
    >
      <Loading fill={isWhiteMode ? Colors.WHITE : '#5f4122'} />
    </div>
  </div>
);

LoadingSpinner.propTypes = {
  className: PropTypes.string,
  isWhiteMode: PropTypes.bool
}

const Spinner = ({ hidden, className }) =>
  hidden ? null : (
    <div className={className}>
      <ReactSVG src={loadingSpinner} />
    </div>
  );
Spinner.propTypes = {
  hidden: PropTypes.bool,
  className: PropTypes.string
}
const ThreeDots = () => (
  <div className="lds-ellipsis">
    <div />
    <div />
    <div />
    <div />
  </div>
);

export { LoadingSpinner, Spinner, ThreeDots };
